import { Close, Download, Print } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Paper,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React from 'react';

import EnhancedTable from '../../../../../../../../../lib/designSystem/Table';
import {
  formatDate,
  formatMoney,
} from '../../../../../../../../../lib/functions/utils';

const DocumentDialog = (props: any) => {
  const { row, openDialog, handleCloseDialog, lines } = props;

  // Calcular totales usando los campos correctos de la data
  const totalDays = row?.Dias || 0;

  const formatRequestId = (id: string) => {
    if (!id) return '';
    if (Number(id) < 0) return `P${id}`;
    return id;
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          width: '60%',
          maxWidth: '800px',
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          px: 2,
          py: 1.5,
        }}
      >
        <Box>
          <Typography variant="h6" component="div" sx={{ fontSize: '1.1rem' }}>
            Documento - {row?.Folio || ''}
          </Typography>
        </Box>
        <IconButton onClick={handleCloseDialog} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1, px: 2 }}>
        {/* Resumen Compacto */}
        <Paper elevation={1} sx={{ p: 2, mb: 2, backgroundColor: '#f8f9fa' }}>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Emisor
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {row?.['Nombre emisor'] || ''}
              </Typography>
            </Grid>

            <Grid item xs={6} sm={3}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Deudor
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {row?.['Nombre deudor'] || ''}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Solicitud
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {formatRequestId(row?.['Id Solicitud'])}
              </Typography>
            </Grid>

            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Devengo Diario
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem', color: '#2e7d32' }}
              >
                {formatMoney(row?.['Devengo diario'])}
              </Typography>
            </Grid>

            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Devengo Total
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem', color: '#1976d2' }}
              >
                {formatMoney(row?.['Devengo total'])}
              </Typography>
            </Grid>

            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Curse
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {row?.['Fecha de operación']
                  ? formatDate(row['Fecha de operación'])
                  : ''}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Vencimiento
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {row?.['Fecha de vencimiento']
                  ? formatDate(row['Fecha de vencimiento'])
                  : ''}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Días
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {totalDays} días
              </Typography>
            </Grid>

            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Fecha de Venta
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {row?.['Fecha de venta']
                  ? formatDate(row['Fecha de venta'])
                  : ''}
              </Typography>
            </Grid>

            <Grid item xs={6} sm={2}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: '0.75rem' }}
              >
                Fecha de Pago
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: '0.85rem' }}
              >
                {row?.['Fecha de pago'] ? formatDate(row['Fecha de pago']) : ''}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Tabla Compacta */}
        <Box>
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{
              color: '#1976d2',
              fontWeight: 600,
              fontSize: '0.9rem',
              mb: 1,
            }}
          >
            Detalle Diario
          </Typography>
          <EnhancedTable
            dataHeaders={[
              { key: 'currentDate', label: 'Fecha', type: 'date' },
              { key: 'dailyAccrual', label: 'Diario', type: 'money' },
              {
                key: 'cumulativeAccrual',
                label: 'Acumulado',
                type: 'money',
              },
            ]}
            data={
              lines?.map((line: any, index: number) => ({
                ...line,
                cumulativeAccrual: lines
                  .slice(0, index + 1)
                  .reduce(
                    (sum: number, l: any) => sum + (l.dailyAccrual || 0),
                    0,
                  ),
              })) || []
            }
            finalSumRow
            rowsPerPageDefault={10}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 1 }}>
        {/* <Button
          startIcon={<Print />}
          variant="outlined"
          size="small"
          onClick={() => {
            window.print();
          }}
        >
          Imprimir
        </Button>
        <Button
          startIcon={<Download />}
          variant="outlined"
          size="small"
          onClick={() => {
            console.log('Descargar reporte');
          }}
        >
          Exportar
        </Button> */}
        <CustomButton
          variant="contained"
          size="small"
          onClick={handleCloseDialog}
        >
          Cerrar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentDialog;
